import { StateCreator } from 'zustand'
import { logger, enqueueLoadedSnackbar, exceptionMessageHandler } from '$utils'
import { SharedSlice } from '../../../../../slice'
import { PayClassification } from '$models'
import { payClassificationService } from '$services'
import { ComplianceSharedSlice } from '../../slice'

interface AddPayClassificationState {
  payClassification: PayClassification | null
}

export interface AddPayClassificationSlice extends AddPayClassificationState {
  /**
   * Reset PayClassification Slice
   */
  resetAddPayClassificationSlice: () => void

  /**
   * Update PayClassification
   * @param payClassification PayClassification to update
   * @param successMessage Success Message to display if the update was successful
   * @param errorMessage Error Message to display if the update has failed
   * @returns
   */
  addPayClassification: (
    payClassification: PayClassification,
    successMessage?: string,
    errorMessage?: string
  ) => Promise<void>
}

const initialState: AddPayClassificationState = {
  payClassification: null,
}

const createAddPayClassificationSlice: StateCreator<
  AddPayClassificationSlice & SharedSlice & ComplianceSharedSlice,
  [],
  [],
  AddPayClassificationSlice
> = (set) => ({
  // State variables
  ...initialState,

  // State setters
  resetAddPayClassificationSlice: () => set(initialState),

  // State API calls
  addPayClassification: async (
    payClassification: PayClassification,
    successMessage?: string,
    errorMessage?: string
  ) => {
    try {
      set(() => ({ isLoading: true }))

      const addedPayClassification: PayClassification | null =
        await payClassificationService.addPayClassification(payClassification)

      if (!addedPayClassification) {
        logger.error(`${errorMessage} - addedPayClassification doesn't exist`)
        enqueueLoadedSnackbar(errorMessage, 'error')
        return
      }

      set((state) => ({
        ...(addedPayClassification && {
          payClassifications: [
            ...state.payClassifications,
            addedPayClassification,
          ],
        }),
      }))
      enqueueLoadedSnackbar(successMessage, 'success')
    } catch (error) {
      exceptionMessageHandler(error, errorMessage)
    } finally {
      set(() => ({ isLoading: false }))
    }
  },
})

export default createAddPayClassificationSlice
